import React from 'react';
import P from 'prop-types';
import styled from '@emotion/styled';

import TextError from './TextError';

const FieldContainer = ({
  children,
  errorMessage,
  formTip,
}) => (
  <>
  {/* // <Container className='col-lg-9'> */}
    {children}
    {/* {console.log('erro', errorMessage)} */}
    <TextError errorMessage={errorMessage} />
    {formTip && <span className="form-text text-muted">{formTip}</span>}
  {/* // </Container> */}
  </>
);

const Container = styled.div`
  position: relative;
  padding-bottom: 15px;
`;

FieldContainer.propTypes = {
  children: P.oneOfType([P.arrayOf(P.node), P.node]).isRequired,
  // errorMessage: P.string,
  errorMessage: P.any,
  formTip: P.string,
};

FieldContainer.defaultProps = {
  errorMessage: '',
  formTip: '',
};

export default FieldContainer;